import { wrap } from 'svelte-spa-router/wrap'
import { needLogin, isLogin } from './auth'

import LoginView from './users/view.login.svelte'
import ShipmentsView from './shipments/view.shipments.svelte'
import UsersView from './users/view.users.svelte'
import UserInfoView from './users/view.user.svelte'
import GraphicsView from './graphics/view.graphics.svelte'
import TrackingPublicView from './tracking/view.tracking.svelte'
import ErrorsView from './errors/view.errors.svelte'
import PickupsView from './pickups/view.pickups.svelte'
import TicketsView from './tickets/view.tickets.svelte'
import CreditsView from './credits/view.credits.svelte'
import AccountsView from './accounts/view.accounts.svelte'
import ChargesView from './charges/view.charges.svelte'
import ShopifyView from './shopify/view.shopifys.svelte'
import FixedpricesView from './fixedprices/view.fixedprices.svelte'
import PricingsView from './pricings/view.pricings.svelte'
import ProvidersView from './providers/view.providers.svelte'
import CoverageView from './til.coverage/view.coverage.svelte'
import TilPricingView from './til.pricing/view.til.pricing.svelte'
import TilTrackingsView from './til.trackings/view.trackings.svelte'
import PrepaidsView from './prepaids/view.prepaids.svelte'
import SeguimientoView from './drivers/view.seguimiento.svelte'
import ZonesView from './til.zones/view.zones.svelte'

const routes = {

    '/tracking': TrackingPublicView,

    '/': wrap({
        component: LoginView,
        conditions: [needLogin]
    }),

    '/shipments': wrap({
        component: ShipmentsView,
        conditions: [isLogin]
    }),

    '/users': wrap({
        component: UsersView,
        conditions: [isLogin]
    }),

    '/user/info': wrap({
        component: UserInfoView,
        conditions: [isLogin]
    }),

    '/graphics': wrap({
        component: GraphicsView,
        conditions: [isLogin]
    }),

    '/pickups': wrap({
        component: PickupsView,
        conditions: [isLogin]
    }),

    '/tickets': wrap({
        component: TicketsView,
        conditions: [isLogin]
    }),

    '/credits': wrap({
        component: CreditsView,
        conditions: [isLogin]
    }),

    '/accounts': wrap({
        component: AccountsView,
        conditions: [isLogin]
    }),

    '/charges': wrap({
        component: ChargesView,
        conditions: [isLogin]
    }),

    '/shopify': wrap({
        component: ShopifyView,
        conditions: [isLogin]
    }),

    '/fixedprices': wrap({
        component: FixedpricesView,
        conditions: [isLogin]
    }),

    '/til-pricing': wrap({
        component: TilPricingView,
        conditions: [isLogin]
    }),

    '/til-trackings': wrap({
        component: TilTrackingsView,
        conditions: [isLogin]
    }),

    '/til-seguimiento': wrap({
        component: SeguimientoView,
        conditions: [isLogin]
    }),

    '/til-zonas': wrap({
        component: ZonesView,
        conditions: [isLogin]
    }),

    '/pricings': wrap({
        component: PricingsView,
        conditions: [isLogin]
    }),

    '/providers': wrap({
        component: ProvidersView,
        conditions: [isLogin]
    }),

    '/coverage': wrap({
        component: CoverageView,
        conditions: [isLogin]
    }),

    '/prepaids': wrap({
        component: PrepaidsView,
        conditions: [isLogin]
    }),

    '/errors': wrap({
        component: ErrorsView,
        conditions: [isLogin]
    }),

}

export { routes }